import type { UseQueryOptions } from '@tanstack/react-query'
import type {
	HttpGetPhotosetImagesOptions,
	HttpGetPhotosetImagesResponse
} from '@/features/photoset/http/photoset.http'
import { useGetPhotosetImages } from '@/features/photoset/queries/use-get-photoset-images'
import { PhotosetImagesSearchParams } from '@/features/photoset/types'
import { useParsedSearchParams } from '@/hooks/use-parsed-search-params'

export const GET_PHOTOSET_IMAGES_LIST_RESPONSE_TYPE = 'extended'

export const useGetPhotosetImagesList = (
	promiseArgs: Omit<HttpGetPhotosetImagesOptions, 'params'>,
	options?: Omit<
		UseQueryOptions<HttpGetPhotosetImagesResponse>,
		'queryFn' | 'queryKey'
	>
) => {
	const { searchParams } = useParsedSearchParams(PhotosetImagesSearchParams)
	return useGetPhotosetImages(
		{
			...promiseArgs,
			params: {
				...searchParams,
				response_type: GET_PHOTOSET_IMAGES_LIST_RESPONSE_TYPE
			}
		},
		options
	)
}
